import { RoundingStrategy } from "./types";
export const roundNumberByStrategy = (value, roundingStrategy) => {
  let round;
  switch (roundingStrategy) {
    case RoundingStrategy.up:
      round = Math.ceil;
      break;
    case RoundingStrategy.down:
      round = Math.floor;
      break;
    case RoundingStrategy.default:
    default:
      round = Math.round;
  }
  return round(value);
};
//# sourceMappingURL=roundNumberByStrategy.js.map